import { useMutation, useQuery } from "@apollo/client";
import React, { useState, useContext, useEffect } from "react";
import beneficiary from "../../gql/beneficiary";

// import { ToastContainer, toast } from "react-toastify";
import toast from "react-hot-toast";
import { appContext } from "../../context/ContextProvider";
import { useNavigate, useParams } from "react-router-dom";

import "./style/payerlist.css";
import Pagination from "../../components/Pagination";
import physicians from "../../gql/physicians";
import AppModal from "../../components/AppModal";
import ConformationModal from "../../components/ConformationModal";
// import FilterModal from "./FilterModal";
import ptpa from "../../gql/ptpa";

import ImportPayerModal from "./ImportPayerModal";

import SearchPayerList from "./SearchPayerList";
import AddPriceListServiceModal from "./AddPriceListServiceModal.js";
import priceList from "../../gql/priceList.js";
import { Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { BiSearch, BiX } from "react-icons/bi";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import AppTable from "../../shared/AppTable";
import AppButton from "../../shared/AppButton";
import TableSkeletonLoader from "../../common/TableLoading";

function PriceListSpecificPayer() {
  const navigate = useNavigate();
  const { payerId, effectiveDate, payerName } = useParams();
  const { t } = useTranslation();
  const { permissions } = useContext(appContext);
  const [item, setItem] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResult, setSearchResult] = useState([]);

  const [showPriceListServiceModal, setShowPriceListServiceModal] =
    useState(false);

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);

  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);

  const [delEntry, { loading: delLoading }] = useMutation(
    priceList.DELETE_PRICE_LIST,
    {
      update(proxy, result) {
        onSuccessfulDelRequestResponse(result.data);
      },
      onError(error) {
        onResponseError(error.graphQLErrors[0]);
      },
    },
  );

  const onSuccessfulDelRequestResponse = (data) => {
    if (data?.deletePriceList) {
      toast.success(data?.deletePriceList?.message);
      refetch({
        input: {
          payer_id: payerId,
          effective_date: effectiveDate,
          limit: limit,
          page: pageNo,
        },
      });
      setShowDeleteAlert(false);
    }
  };

  const onResponseError = (error) => {
    toast.error(`${error.message}`);
  };

  const { loading, error, data, refetch } = useQuery(
    priceList.GET_SPECIFIC_PRICE_LIST_LIST,
    {
      variables: {
        input: {
          payer_id: payerId,
          effective_date: effectiveDate,
          limit: limit,
          page: pageNo,
        },
      },
    },
  );

  const { loading: loadingPriceListByID, refetch: refetchPriceListByID } =
    useQuery(priceList.GET_PRICE_LIST_BY_ID, {
      variables: {
        id: currentItem?.id,
      },
      skip: true,
    });

  const onPageChange = (currentPage) => {
    setPageNo(currentPage);
    refetch({
      input: {
        payer_id: payerId,
        effective_date: effectiveDate,
        limit: limit,
        page: currentPage,
      },
    });
  };

  const onClickDelete = (item) => {
    setCurrentItem(item);
    setShowDeleteAlert(true);
  };

  const deleteEntry = () => {
    delEntry({
      variables: {
        input: {
          effective_date: "",
          payer_id: "",
          id: currentItem.id,
        },
      },
    });
    setShowDeleteAlert(false);
  };

  const handleEdit = (data) => {
    setCurrentItem(data);
    if (data) {
      refetchPriceListByID({ variables: { id: data?.id } }).then((res) => {
        setItem(res?.data?.getPriceListById?.data);
        setShowPriceListServiceModal(true);
      });
    }
  };

  const {
    loading: loadingSearchPriceListCode,
    refetch: refetchSearchPriceListCode,
  } = useQuery(priceList.SEARCH_PRICE_LIST_CODE, {
    variables: {
      input: "",
      payerId: payerId,
    },
    skip: true,
  });

  const handleSearch = (term) => {
    refetchSearchPriceListCode({
      input: term,
      payerId: payerId,
    }).then((res) => {
      setSearchResult(res?.data?.searchPriceListCode?.data || []);
    });
  };

  const debouncedSearch = _.debounce(handleSearch, 1000);

  const handleSearchChange = (event) => {
    const newSearchTerm = event.target.value;
    setSearchTerm(newSearchTerm);
    if (newSearchTerm.length >= 3) {
      debouncedSearch(newSearchTerm);
    } else {
      setSearchResult([]);
    }
  };

  const columns = [
    {
      header: t("SQ #"),
      render: (row, index) => pageNo * limit + index + 1 - limit,
    },
    {
      header: t("Service Type"),
      render: (row) => (
        <span className="capitalize font-medium text-slate-700">
          {row.service_type.length > 100 ? (
            <Tooltip title={row.service_type}>
              <span>{row.service_type.slice(0, 100)}...</span>
            </Tooltip>
          ) : (
            row.service_type
          )}
        </span>
      ),
    },
    { header: t("Standard Code"), field: "service_code" },
    {
      header: t("Standard Description"),
      render: (row) => (
        <span className="capitalize">
          {row.service_desc.length > 100 ? (
            <Tooltip title={row.service_desc}>
              <span>{row.service_desc.slice(0, 100)}...</span>
            </Tooltip>
          ) : (
            row.service_desc
          )}
        </span>
      ),
    },
    { header: t("Non-Standard Code"), field: "non_standard_code" },
    {
      header: t("Non-Standard Description"),
      render: (row) => (
        <span className="capitalize">
          {row.non_standard_desc.length > 100 ? (
            <Tooltip title={row.non_standard_desc}>
              <span>{row.non_standard_desc.slice(0, 100)}...</span>
            </Tooltip>
          ) : (
            row.non_standard_desc
          )}
        </span>
      ),
    },
    { header: t("Unit Price"), field: "unit_price" },
    { header: t("Factor"), field: "factor" },
  ];

  return (
    <div className="priceList_container !p-0">
      <div className="flex justify-between flex-col lg:flex-row gap-4 mb-3">
        <div className="flex !gap-3">
          <div
            className="back bg-primary !h-[24px] !w-[24px] my-auto cursor-pointer hover:bg-slate-100 p-1 rounded-full transition-colors"
            onClick={() => navigate(-1)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M9 19L10.41 17.59L5.83 13H22V11H5.83L10.42 6.41L9 5L2 12L9 19Z"
                fill="white"
              ></path>
            </svg>
          </div>

          <div className="">
            <Tooltip
              placement="right"
              title="Keep track of your pricelists specific payer"
              className="my-auto !mt-2"
            >
              <div className="font-semibold text-black/70 text-lg leading-tight">
                <span className="text-xs uppercase text-slate-500 font-bold tracking-wider">
                  {t("Payer")}
                </span>
                <div className="font-bold text-[#0070C2] text-sm">
                  {payerName || ""}
                </div>
                <div className="text-xs text-slate-500 mt-1 uppercase font-bold tracking-wider">
                  {t("Effective Date")}:{" "}
                  <span className="text-slate-700">
                    {effectiveDate?.substring(0, 10) || ""}
                  </span>
                  <span className="ml-2 italic normal-case font-medium">
                    ({data?.listPayerPriceList?.total || 0} {t("Entries")})
                  </span>
                </div>
              </div>
            </Tooltip>
          </div>
        </div>

        <div className="my-auto">
          <div className="flex gap-3 flex-col md:flex-row">
            <AppButton
              label={t("Add Price List Service")}
              onClick={() => setShowPriceListServiceModal(true)}
              startIcon={<AddIcon />}
            />
          </div>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-2 mb-2">
        <div className="relative">
          <span className="absolute inset-y-0 left-0 pl-3 flex items-center">
            <BiSearch className="h-5 w-5 text-slate-400" />
          </span>
          <input
            type="text"
            placeholder={t(
              "Search for item by Service Code or Service Description",
            )}
            onChange={handleSearchChange}
            value={searchTerm}
            className="block w-full py-2.5 pl-10 pr-10 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#0070C2] focus:border-transparent outline-none transition-all text-sm"
          />
          {searchTerm.length > 0 && (
            <span
              className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer text-slate-400 hover:text-slate-600"
              onClick={() => {
                setSearchResult([]);
                setSearchTerm("");
              }}
            >
              <BiX className="h-6 w-6" />
            </span>
          )}
        </div>
      </div>

      <AppTable
        columns={columns}
        data={
          searchTerm.length > 2 ? searchResult : data?.listPayerPriceList?.data
        }
        loading={
          loading ||
          delLoading ||
          loadingPriceListByID ||
          loadingSearchPriceListCode
        }
        onEdit={handleEdit}
        onDelete={onClickDelete}
        LoaderComponent={
          <TableSkeletonLoader columnCount={columns.length + 1} rowCount={10} />
        }
      />

      <div className="">
        {searchTerm.length > 2 ? null : (
          <Pagination
            currentPage={pageNo}
            totalPages={data?.listPayerPriceList?.pages}
            onPageChange={onPageChange}
          />
        )}
      </div>

      <ConformationModal
        open={showDeleteAlert}
        setOpen={setShowDeleteAlert}
        onDelete={deleteEntry}
      />

      <AddPriceListServiceModal
        showPriceListServiceModal={showPriceListServiceModal}
        setShowPriceListServiceModal={setShowPriceListServiceModal}
        item={item}
        refetchSpecificPriceList={refetch}
        pageNo={pageNo}
        limit={limit}
      />
    </div>
  );
}

export default PriceListSpecificPayer;

// export default PriceListSpecificPayer;
